module.exports = __webpack_public_path__ + "media/to-the-point.f1b116bc.mp3";